import { rudderVisitPage } from "./init";

export async function parseLocation({ path }: { path: string }): Promise<void> {
  const pageName = `${path.split("/").slice(1).join(" ").trim()} viewed`;
  await rudderVisitPage(
    pageName,
    { name: pageName, url: path }
  );
}
